import { Component, inject, OnInit } from '@angular/core';
import { SelectAirportComponent } from '../select-airport/select-airport.component';
import { ButtonModule } from 'primeng/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';

@Component({
  selector: 'app-airport-form',
  imports: [SelectAirportComponent, ButtonModule, TranslocoPipe],
  templateUrl: './airport-form.component.html',
})
export class AirportFormComponent implements OnInit {
  transportFormService = inject(TransportFormService);
  draggedIndex: number | null = null;

  ngOnInit() {
    this.transportFormService.createAirportControls();
  }

  /** Translation suffix used for the row's label/placeholder, derived from position. */
  placeholderFor(index: number, isLast: boolean): string {
    if (index === 0) return 'from';
    if (isLast) return 'to';
    return 'transit';
  }

  // ── Drag & drop: DOM plumbing only; reordering itself lives in the service ──
  onDragStart(event: DragEvent, index: number): void {
    this.draggedIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  }

  onDrop(event: DragEvent, dropIndex: number): void {
    event.preventDefault();
    if (this.draggedIndex === null) return;
    this.transportFormService.reorderFlightStop(this.draggedIndex, dropIndex);
    this.draggedIndex = null;
  }

  onDragEnd(): void {
    this.draggedIndex = null;
  }
}
